import { Action } from 'redux';
import { Dispatch } from 'react-redux';
import { PageViewModel } from '@models/common.models';
import { toast } from 'react-toastify';
import { ToastComponent, ToastType } from '@common/components';
import * as React from 'react';
import { ToastOptions } from '@common/components/toast/toast';
import { ServiceWorkOrderSearchViewModel, SWODispatchViewModel } from '@models/ServiceWorkOrder';
import { swoService } from '@services/ServiceWorkOrderService';

export enum ZeroVendorActionType {
  SearchZeroVendorListStart = 'SearchZeroVendorListStart',
  SearchZeroVendorListSuccess = 'SearchZeroVendorListSuccess',
  SearchZeroVendorListFailure = 'SearchZeroVendorListFailure'
}

/***** Search Zero Vendor List *****/
export interface SearchZeroVendorListStartAction extends Action {
  readonly type: ZeroVendorActionType.SearchZeroVendorListStart;
  readonly query: string | null;
}
export interface SearchZeroVendorListSuccessAction extends Action {
  readonly type: ZeroVendorActionType.SearchZeroVendorListSuccess;
  readonly pageNumber: number;
  readonly pageSize: number;
  readonly orderBy: string;
  readonly result: PageViewModel<ServiceWorkOrderSearchViewModel>;
}

export interface SearchZeroVendorListFailureAction extends Action {
  readonly type: ZeroVendorActionType.SearchZeroVendorListFailure;
  readonly error: string;
}

/***** Search Zero Vendor List *****/
export function searchSwoList(
  query: string | null,
  pageSize: number,
  pageNumber: number,
  orderBy: string,
  orderDirection: string
) {
  return async (dispatch: Dispatch<SWODispatchViewModel>) => {
    dispatch(searchZeroVendorListStart(query));
    try {
      const result: PageViewModel<ServiceWorkOrderSearchViewModel> = await swoService.getZeroVendorSwos(
        pageNumber,
        pageSize,
        orderBy,
        orderDirection,
        query ? query : undefined
      );
      dispatch(searchZeroVendorListSuccess(pageNumber, pageSize, orderBy, result!));
    } catch (e) {
      dispatch(searchZeroVendorListFailure(e.toString()));
    }
  };
}
export function searchZeroVendorListStart(query: string | null): SearchZeroVendorListStartAction {
  return {
    type: ZeroVendorActionType.SearchZeroVendorListStart,
    query: query
  };
}
export function searchZeroVendorListSuccess(
  pageNumber: number,
  pageSize: number,
  orderBy: string,
  result: PageViewModel<ServiceWorkOrderSearchViewModel>
): SearchZeroVendorListSuccessAction {
  return {
    type: ZeroVendorActionType.SearchZeroVendorListSuccess,
    pageNumber: pageNumber,
    pageSize: pageSize,
    orderBy: orderBy,
    result: result
  };
}
export function searchZeroVendorListFailure(error: string): SearchZeroVendorListFailureAction {
  toast.error(<ToastComponent type={ToastType.Error} message={error.toString()} />, ToastOptions.Error);
  return {
    type: ZeroVendorActionType.SearchZeroVendorListFailure,
    error: error
  };
}



// WEBPACK FOOTER //
// ./src/service-work-order/zero-vendor/zero-vendor.actions.tsx